import React from "react";
import "./Hosting.css";
import { FaServer, FaMobileAlt, FaCloud, FaShieldAlt } from "react-icons/fa";

const services = [
  {
    id: 1,
    title: "Website Hosting",
    description: "Ultra-fast hosting with enterprise-grade security.",
    icon: <FaServer />,
    image: "/images/banner/124.png",
  },
  {
    id: 2,
    title: "Mobile App Hosting",
    description: "Deploy mobile apps seamlessly on cloud servers.",
    icon: <FaMobileAlt />,
    image: "/images/banner/125.png",
  },
  {
    id: 3,
    title: "Cloud Hosting",
    description: "Reliable and scalable cloud solutions for businesses.",
    icon: <FaCloud />,
    image: "/images/banner/123.png",
  },
  {
    id: 4,
    title: "Security Services",
    description: "Advanced encryption & real-time threat protection.",
    icon: <FaShieldAlt />,
    image: "/images/banner/122.png",
  },
];

const Hosting = () => {
  return (
    <div className="hosting-container">
      <header className="hosting-header">
        <h1>Premium Hosting Services</h1>
        <p>Reliable and Secure Web & Mobile Hosting Solutions</p>
      </header>

      <section className="hosting-services">
        {services.map((service) => (
          <div key={service.id} className="hosting-service-card">
            <img src={service.image} alt={service.title} className="hosting-service-image" />
            <div className="hosting-service-icon">{service.icon}</div>
            <h2>{service.title}</h2>
            <p>{service.description}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default Hosting;
